<p-dialog [(visible)]="entry" [breakpoints]="{ '960px': '50vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'calendar']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">{{ entry.employee.nickName }} - {{ app.moment(entry.startDateTime).format('l') }}</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<ng-template pTemplate="content">
		<div class="d-flex w-100">
			<span class="p-float-label mt-4">
				<p-dropdown
					#entryJobSelect
					[options]="entry.employee.jobs"
					optionValue="id"
					optionLabel="name"
					name="entryJobSelect"
					[(ngModel)]="entry.jobId"
					[style]="{ width: '100%' }"
					appendTo="body"
					(onChange)="calculateTime()"
				>
					<ng-template let-rec pTemplate="item">
						<div class="display-14">
							<div>{{ rec.name }} - {{ rec.payRate | currency }} /hr</div>
						</div>
					</ng-template>
				</p-dropdown>
				<label for="entryJobSelect">Job</label>
			</span>
		</div>
		<div class="d-flex">
			<span class="p-float-label mt-4 me-2">
				<p-calendar
					#entryStartTimeInput
					name="entryStartTimeInput"
					[timeOnly]="true"
					[(ngModel)]="entryStartTime"
					appendTo="body"
					(onSelect)="calculateTime()"
					(onInput)="calculateTime()"
				></p-calendar>
				<label for="entryStartTimeInput">Shift Start</label>
			</span>
			<span class="p-float-label mt-4 ms-2">
				<p-calendar
					#entryEndTimeInput
					name="entryEndTimeInput"
					[timeOnly]="true"
					[(ngModel)]="entryEndTime"
					appendTo="body"
					(onSelect)="calculateTime()"
					(onInput)="calculateTime()"
				></p-calendar>
				<label for="entryEndTimeInput">Shift End</label>
			</span>
			<div *ngIf="entry.startDateTime && entry.endDateTime && entry.endDateTime > entry.startDateTime" class="display-14 d-flex flex-column">
				<div class="my-auto ms-4">
					<div>{{ hoursMinutes }}</div>
					<div>Est. Cost {{ entry.cost | currency }}</div>
					<small><i>estimated cost excludes overtime</i></small>
				</div>
			</div>
		</div>
		<div class="d-flex w-100">
			<span class="p-float-label mt-4 w-100">
				<textarea
					pInputTextarea
					#laborEntryShiftNotesInput
					name="laborEntryShiftNotesInput"
					[(ngModel)]="entry.shiftNotes"
					class="w-100 mt-1"
				></textarea>
				<label for="laborEntryShiftNotesInput">Shift Notes</label>
			</span>
		</div>
		<div class="d-flex">
			<small class="text-italics">Shift notes are visible to employees when viewing the schedule online. Shift notes do not display on POS.</small>
		</div>
	</ng-template>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			(onCancelChange)="cancel()"
			(onDeleteChange)="delete()"
			(onSaveChange)="savePrompt()"
			[cancelDisabled]=""
			[deleteDisabled]="deleteDisabled()"
			[saveDisabled]="saveDisabled()"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
